// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"368":"c4c67656","815":"96f2f71b"}[chunkId] + ".css";
};